import { Controller } from "@hotwired/stimulus"

// Reminder lead-time picker on the meeting form (Quentin 2026-08-06).
// The preset <select> and the "Custom…" minutes box both feed ONE hidden
// field, so the server just reads meeting[reminder_lead_minutes]:
//   ""  → inherit the company default
//   "0" → no reminder for this meeting
//   n   → n minutes before the start
export default class extends Controller {
  static targets = ["preset", "custom", "customWrap", "field"]

  presetChanged() {
    const value = this.presetTarget.value
    const isCustom = value === "custom"
    this.customWrapTarget.classList.toggle("hidden", !isCustom)

    if (isCustom) {
      // Seed the box with something sensible so the field is never left
      // holding the literal string "custom".
      if (!this.customTarget.value) this.customTarget.value = "15"
      this.fieldTarget.value = this.customTarget.value
      this.customTarget.focus()
    } else {
      this.fieldTarget.value = value
    }
  }

  customChanged() {
    this.fieldTarget.value = this.customTarget.value
  }
}
